import { render, staticRenderFns } from "./DateDisplayField.vue?vue&type=template&id=2471d410&scoped=true&"
import script from "./DateDisplayField.vue?vue&type=script&lang=js&"
export * from "./DateDisplayField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2471d410",
  null
  
)

export default component.exports